
import { createContext, useContext, useState, useEffect } from 'react';
import { getSettings } from '../api/settings.api';
import { HashLoader } from 'react-spinners';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState('');
    const [termOfService, setTermOfService] = useState([]);
    const [privacyPolicy, setPrivacyPolicy] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await getSettings();
                if (res.success) {
                    setSettings(JSON.parse(res.data.settings.config));
                    setTermOfService(res.data.settings.term_of_service);
                    setPrivacyPolicy(res.data.settings.privacy_policy);
                }
            } catch (err) {
                console.error("Failed to load settings:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchSettings();
    }, []);

    if (loading) {
        return (
            <div style={{
                width: "100%",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <HashLoader color="#0d79e2" />
            </div>
        );
    }

    return (
        <SettingsContext.Provider value={{settings, privacyPolicy, termOfService}}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);
